// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-select[data-v-246e9877]{all:unset;display:flex;padding:12px 16px;align-items:center;gap:12px;border-radius:8px;background-color:var(--background-bg-medium,#111924)}.disabled[data-v-246e9877]{color:var(--text-color-disabled,#7d7d7d)}", ""]);
// Exports
module.exports = exports;
